import { render, staticRenderFns } from "./TournamentEdit.vue?vue&type=template&id=6092af3a&scoped=true"
import script from "./TournamentEdit.vue?vue&type=script&lang=js"
export * from "./TournamentEdit.vue?vue&type=script&lang=js"
import style0 from "./TournamentEdit.vue?vue&type=style&index=0&id=6092af3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6092af3a",
  null
  
)

export default component.exports